import styles from './index.less';

import React, { useEffect, useState } from 'react';
import { Table, Tag, message, Image } from 'antd';
import { getListTenantSpecialCourse } from '@/services/athena';
const SpecialCourses = (props) => {
  const { tenantId } = props;
  const [pageData, setPageData] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
  });
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    initSpecialCourses(pageData);
  }, [tenantId]);

  const initSpecialCourses = (pageData) => {
    if (!tenantId) {
      return;
    }
    const params = {
      requestData: { tenantId },
      page: pageData,
    };
    getListTenantSpecialCourse(params).then((res) => {
      if (res.code !== '00000') {
        message.error(res.msg);
        return;
      }
      setPageData({
        ...pageData,
        count: res?.page?.count,
      });
      setTableData(res.data || []);
    });
  };

  const handlerPage = (page) => {
    const pages = {
      currentPage: page.current,
      pageSize: page.pageSize,
    };
    setPageData({ ...pageData, ...pages });
    initSpecialCourses(pages);
  };

  const columns = [
    {
      title: '课程ID',
      key: 'id',
      dataIndex: 'id',
    },
    {
      title: '课程封面',
      key: 'coverUrl',
      dataIndex: 'coverUrl',
      render: (text) => {
        return (
          <Image
            height={73}
            width={140}
            src={text}
            className={styles.imgCover}
          />
        );
      },
    },
    {
      title: '课程名称',
      key: 'courseName',
      dataIndex: 'courseName',
      width: 200,
      render: (text, record) => {
        return (
          <a
            href={`/action/featureCourse/detail?id=${record.courseIdent}&courseType=${record.courseType}`}
            target="_blank"
            rel="noreferrer"
          >
            {text}
          </a>
        );
      },
    },
    {
      title: '主要训练部位',
      key: 'trainingPartsName',
      dataIndex: 'trainingPartsName',
      render: (text) => {
        return <Tag>{text}</Tag>;
      },
    },
    {
      title: '课程时长',
      key: 'trainingMinutes',
      dataIndex: 'trainingMinutes',
      render: (text) => {
        return text + '分钟';
      },
    },
    {
      title: '是否精选',
      dataIndex: 'isCarefulChoose',
      key: 'isCarefulChoose',
      render: (text) => {
        return <Tag color={text ? 'green' : 'red'}>{text ? '是' : '否'}</Tag>;
      },
    },
    {
      title: '创建人',
      key: 'creatorName',
      dataIndex: 'creatorName',
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={tableData}
      scroll={{ x: 'max-content' }}
      pagination={{
        total: pageData.count,
        pageSize: pageData.pageSize,
        showTotal: (total, range) =>
          `第 ${range[0]}-${range[1]} 条/总共 ${total} 条`,
      }}
      onChange={handlerPage}
    />
  );
};

export default SpecialCourses;
